// extracted by mini-css-extract-plugin
export default {"container":"chat-messages_container__D7YX+","text":"chat-messages_text__RZinq"};